<template>
	<div style="position: fixed; width: 100%; bottom: 0; background: #365F79; color: white;" v-show="contextualizationPanelVisible">
        <div class="container is-fluid">
            <div class="level is-marginless">
                <div class="level-left">
                    <p class="title" style="font-size: 1.25rem; margin-top: 6px; margin-bottom: 18px; color: white; padding-top: 10px;">Contextualisation des lignes du temps
                    </p>
                </div>
                <div class="level-right">
                    <div class="level-item" v-if="contextualizationTimelines.length > 1 && contextualizationPanelExtended">
                        <span class="has-text-white" @click="cleanContextualizationTimelines">Effacer ma sélection</span>
                    </div>
                    <div class="level-item" v-if="contextualizationTimelines.length <= 1">
                        <a class="button is-white" disabled="disabled">Contextualiser</a>
                    </div>
                    <div class="level-item" v-else>
                        <router-link :to="{ name: 'contextualization.show'}" class="button is-white" exact>Contextualiser</router-link>
                    </div>
                    <div class="level-item" style="padding-left: 1.25rem;" @click="togglePanelState">
                        <i aria-hidden="true" class="fa fa-angle-down fa-3x" v-if="contextualizationPanelExtended"></i>
                        <i aria-hidden="true" class="fa fa-angle-up fa-3x" v-else></i>
                    </div>
                </div>
            </div>
            <div class="columns" style="margin-bottom: 12px;" v-show="contextualizationPanelExtended">
                <div class="column is-3" v-for="timeline in contextualizationTimelines">
                    <div style="height: 120px; padding: 0.75rem; border: 1px solid white; background: white;">
                        <div class="media">
                            <figure class="media-left" v-if="timeline.avatar">
                        	   <p class="image" style="width: 96px; height: 96px;">
                        		  <img :src="timeline.avatar.url">
                    		  </p>
                    	   </figure>
                            <div class="media-content">
                                <div class="has-text-grey-light has-text-right" style="margin-right: -5px; margin-top: -5px;">
                                    <i aria-hidden="true" class="fa fa-times-circle-o" @click="removeTimelineFromContextualization(timeline)"></i>
                                </div>
                                <div>
                                    <router-link :to="{ name: 'timelines.show', params: { id: timeline.id }}" exact>
                                        <b class="has-text-primary" style="max-width: 40ch; margin-bottom: 5px;">{{ timeline.title }}</b>
                                    </router-link>
                           	    </div>
                            </div>
						</div>
                    </div>
                </div>

                <div class="column is-3" v-for="i in 4 - contextualizationTimelines.length">
                    <div style="height: 120px; padding: 0.75rem; border: 1px dashed white;">
                        &nbsp;
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
	export default {

        computed: {
            contextualizationTimelines() {
                return this.$store.getters.contextualizationTimelines;
            },

            contextualizationPanelExtended() {
                return this.$store.getters.contextualizationPanelState;
            },

            contextualizationPanelVisible() {
                return this.$store.getters.contextualizationPanelVisibility;
            },
            

        },

        methods: {
            togglePanelState() {
                this.$store.dispatch('toogleContextualizationPanelStatus');
            },

            cleanContextualizationTimelines() {
                this.$store.dispatch('cleanContextualizationTimelines');
            },

            removeTimelineFromContextualization(timeline) {
                this.$store.dispatch('removeTimelineFromContextualization', timeline);
            }
        }
	}
</script>